// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1xDaJ","error":"Textarea_error__2SavR","readonly":"Textarea_readonly__2oyaw","disabled":"Textarea_disabled__Z6SJs"};